import { withInstall } from '../../utils'

import _Drawer from './src/drawer.vue'

export const SdDrawer = withInstall(_Drawer)
export default SdDrawer

export * from './src/drawer'
